import Image from 'next/image';
import React from 'react';
export default function LaunchPadView() {
  return <>
      <div className='flex items-center justify-center'>
        <div className='h-[70vh] mt-4 flex items-center justify-center launchpadView mx-4 rounded-lg'>
          <div className='max-w-md w-full rounded-lg text-white ta-c max-w-[337px]'>
            <div className='my-8 flex items-center justify-center'>
              <Image src='/static/tokenlogos/moon.png' alt='logo' width={50} height={50} data-sentry-element="Image" data-sentry-source-file="LaunchPadView.tsx" />
              <Image src='/static/tokenlogos/pill.png' className='ml-[-25px]' alt='logo' width={50} height={50} data-sentry-element="Image" data-sentry-source-file="LaunchPadView.tsx" />
            </div>
            <h2 className='text-[32px] text-genius-gradient font-bold mb-2 px-10 font-medium tracking-tighter'>
              Launchpads are coming soon
            </h2>
            <p className='mt-5 mb-6 text-genius-gradient-dark text-sm w-[300px]'>
              Genius will aggregate popular launchpads like Pump.fun and Moonshot to give users the
              ability to buy memes with any balance.
            </p>
          </div>
        </div>
      </div>
    </>;
}